import Vue from 'vue'
import moment from 'moment'

Vue.filter('timeStamp', (value, format = 'DD/MM/YYYY HH:mm:ss') => {
  return value ? moment(value).format(format) : ''
})



// WEBPACK FOOTER //
// ./src/filters/timeStampFilter.js